import { addExistingItemQuantity } from './addExistingItemQuantity';
export const aggregateOffers = (offers) => {
    if (!offers) {
        return [];
    }
    return offers.reduce((accumulator, offer) => {
        const existingOffer = accumulator.find((orderOffer) => orderOffer.variantId === offer.variantId);
        if (existingOffer) {
            return addExistingItemQuantity(accumulator, existingOffer);
        }
        return [...accumulator, offer];
    }, []);
};
